<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/**
 * 模块说明 饼图（根据份额决定大学）Eachart
 * @module chart
 * param Object chartData [{name,value}]
 */
import * as echarts from "echarts"; // echarts theme
import resize from "./mixins/resize";
require("echarts/theme/macarons");
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "学科分布"
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions(chartData) {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 12
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "成果数量",
            type: "pie",
            roseType: "radius",
            radius: [15, 95],
            center: ["50%", "55%"],
            data: chartData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
      this.chart.hideLoading();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Charts/PieChart.vue